/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (boostSDAppConfig?.filterSettings) {
    boostSDAppConfig.filterSettings.filterLayout = 'vertical';
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'ProductList - call get Products Data',
            apply() {
                return {
                    async afterRender(element) {
                        // Theme's Quick Shop button 
                        let productData = element.getParams().props.product;
                        let productId = productData.id;
                        if (productData?.split_product) {
                            productId = productData.variant_id;
                        }
                        if (productData?.collections) {
                            const newCollect = productData.collections.filter(function(e) {
                                return e.title == 'New' || e.id == '126355243108';
                            })
                            console.log(newCollect);
                            if (typeof newCollect[0] !== 'undefined') {
                                let productItems = document.querySelectorAll('[data-product-id="' + productId + '"]');
                                const newLabelHtml = '<div class="boost-sd__product-label boost-sd__product-label--rectangle boost-sd__product-label--new" style="color: rgb(255, 255, 255); background-color: rgb(0, 0, 0);">' + '<span class="boost-sd__product-label-text">' + '<span>New</span>' + '</span>' + '</div>';
                                for (let productItem of productItems) {
                                    if (productItem.querySelector('.boost-sd__product-image-row.boost-sd__product-image-row--top') && !productItem.querySelector('.boost-sd__product-label--new')) {
                                        productItem.querySelector('.boost-sd__product-image-row.boost-sd__product-image-row--top').insertAdjacentHTML('beforeend', newLabelHtml);
                                    }
                                }
                            }
                        }
                    },
                };
            },
        });
    }
]);